import React from 'react';
import { FaCalendar, FaWhatsapp } from 'react-icons/fa';
import { CiLocationOn } from "react-icons/ci";
import './Booking.css';
import doctorImage from '../../assets/draramirez.jpg';

const doctors = [
  {
    id: 1,
    name: 'Dra. Walquiria Ramirez',
    description: 'Clínica médica',
    image: doctorImage,
    locations: [
      {
        name: 'Taien',
        address: 'Rodriguez 548',
        schedule: {
          'M': null,
          'T': { from: '08:00', to: '12:00' },
          'W': { from: '16:00', to: '19:30' },
          'Th': null,
          'F': null,
          'S': null,
          'Su': null
        },
        phone: '+542494649711',
        url: 'https://mediware.com.ar/taien/'
      },
      {
        name: 'Consultorios Colón',
        address: 'Av. Colón 1215',
        schedule: {
          'M': null,
          'T': { from: '14:00', to: '18:00' },
          'W': null,
          'Th': null,
          'F': { from: '09:30', to: '12:30' },
          'S': null,
          'Su': null
        },
        phone: '+542494511020',
        url: 'https://mediware.com.ar/ConsultoriosColon'
      }
    ]
  }
];

const days = [
  { key: 'M', label: 'L' },
  { key: 'T', label: 'M' },
  { key: 'W', label: 'M' },
  { key: 'Th', label: 'J' },
  { key: 'F', label: 'V' },
  { key: 'S', label: 'S' },
  { key: 'Su', label: 'D' }
];

const ScheduleDisplay = ({ schedule }) => {
  return (
    <div className="schedule-container">
      <div className="days-row">
        {days.map(({ key, label }) => (
          <div key={key} className={`day-header ${schedule[key] ? 'active' : ''}`}>
            {label}
          </div>
        ))}
      </div>
      <div className="hours-rows">
        <div className="hours-row from-row">
          {days.map(({ key }) => (
            <div key={`${key}-from`} className={`time-cell ${schedule[key] ? 'active-time' : ''}`}>
              {schedule[key] ? (
                <>
                  <span className="time-num">{schedule[key].from}</span>
                  <span className="time-unit">hs</span>
                </>
              ) : (
                <span className="time-dash">-</span>
              )}
            </div>
          ))}
        </div>
        <div className="hours-row to-row">
          {days.map(({ key }) => (
            <div key={`${key}-to`} className={`time-cell ${schedule[key] ? 'active-time' : ''}`}>
              {schedule[key] ? (
                <>
                  <span className="time-num">{schedule[key].to}</span>
                  <span className="time-unit">hs</span>
                </>
              ) : (
                <span className="time-dash">-</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const LocationTabs = ({ locations }) => {
  const [activeTab, setActiveTab] = React.useState(0);

  return (
    <div className="location-tabs">
      <div className="tab-headers">
        {locations.map((location, index) => (
          <button
            key={index}
            className={`tab-header ${activeTab === index ? 'active' : ''}`}
            onClick={() => setActiveTab(index)}
          >
            {location.name}
          </button>
        ))}
      </div>
      <div className="tab-contents">
        {locations.map((location, index) => (
          <div
            key={index}
            className={`tab-content ${activeTab === index ? 'active' : ''}`}
          >
            <div className="location-info">
              <div className="schedule-wrapper">
                <ScheduleDisplay schedule={location.schedule} />
              </div>
              <div className="location-links">
                <a
                  href={location.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="location-url"
                >
                  <FaCalendar /> Agendar Turno
                </a>
                <a
                  href={`https://wa.me/${location.phone}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-link"
                >
                  <FaWhatsapp /> {location.phone}
                </a>
              </div>
              <p className="location-address">
                <CiLocationOn className="location-icon" />
                <span>{location.address}</span>
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Booking = () => {
  return (
    <section id="booking" className="booking-section">
      <h1>Pedir turno</h1>
      <div className="doctor-cards">
        {doctors.map(doctor => (
          <div key={doctor.id} className="doctor-card">
            <div className="booking-info">
              <LocationTabs locations={doctor.locations} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Booking;
